import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types'
import fonts from '../../../../lib/Fonts';
import colors from '../../../../lib/Colors';

const RadioButton = styled.div`
  font-family: ${fonts.family.workSans};
  font-size: 14px;
  color: ${props => (props.isSelected ? `${colors.blue}` : `${colors.colorDefaultText}`)};
  font-weight: 600;
  margin: 5px;
  cursor: pointer;
  width: ${props => (props.size ? props.size : 16)}px;
  height: ${props => (props.size ? props.size : 16)}px;
  position: relative;
  label {
    margin-left: 25px;
  }
  &::before {
    content: "";
    border-radius: 100%;
    border: 2px solid
      ${props => (props.isSelected ? `${colors.blue}` : `${colors.colorDefaultText}`)};
    background: ${props => props.backgroundColor ? props.backgroundColor : `${colors.almostWhite}`};
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    box-sizing: border-box;
    pointer-events: none;
    z-index: 0;
  }
`;

const Fill = styled.div`
  background: ${props => (props.fillColor ? props.fillColor : `${colors.blue}`)};
  width: 0;
  height: 0;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.2s ease-in, height 0.2s ease-in;
  pointer-events: none;
  z-index: 1;

  &::before {
    content: "";
    opacity: 0;
    width: calc(16px - 4px);
    position: absolute;
    height: calc(16px - 4px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 100%;
  }
`;

const Input = styled.input`
  opacity: 0;
  z-index: 2;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:checked {
    & ~ ${Fill} {
      width: calc(100% - 8px);
      height: calc(100% - 8px);
      transition: width 0.2s ease-out, height 0.2s ease-out;

      &::before {
        opacity: 1;
        transition: opacity 1s ease;
      }
    }
  }
`;

const Root = styled.div`
  width: 120px;
`;

const Radio = ({name, onChange, value, isSelected, labelText}) => {
  return (
    <Root>
      <RadioButton isSelected={isSelected}>
        <label>
          {labelText}
          <Input
            aria-checked={isSelected}
            checked={isSelected}
            name={name}
            onChange={onChange}
            type="radio"
            value={value}
          />
          <Fill/>
        </label>
      </RadioButton>
    </Root>
  );
};

Radio.propTypes = {
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  labelText: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any
};

Radio.defaultProps = {
  onChange: () => {
  },
  value: '',
  labelText: ''
};

export default Radio;
